<div class="dialog-content" role="dialog" aria-labelledby="dialogTitle" aria-modal="true">
  <div class="dialog-header">
    <h2 class="title" id="dialogTitle">{{ config.data.title }}</h2>
    <div>
      <button
        data-no-search
        pRipple
        class="close-icon"
        [pAutoFocus]="true"
        aria-label="Dialog schliessen"
        (click)="closeDialog()"
        >
        <img src="/assets/icons/close-icon.svg" alt="Dialog schliessen" />
      </button>
    </div>
  </div>
  <div class="profile-dialog-main">
    <div>
      <faro-dialog-panel header="Ablagestruktur"></faro-dialog-panel>
      <div class="dialog-options">
        @for (filter of availableFilters; track filter) {
          <div class="dialog-options-entries">
            <div class="checkbox-label">{{ filter.label }}</div>
            <div>
              <p-toggleSwitch
                (onChange)="filterTree()"
                [(ngModel)]="filter.active"
                [ariaLabel]="filter.label"
              ></p-toggleSwitch>
            </div>
          </div>
        }
      </div>
      @if (isLoadingCategories) {
        <faro-tree-select class="tree-select" [isLoading]="isLoadingCategories"></faro-tree-select>
      }
      @if (!isLoadingCategories) {
        <faro-tree-select
          class="tree-select"
          [excludedNodes]="excludedStorageCategories"
          [treeEntries]="storageCategories"
          [isLoading]="isLoadingCategories"
          (excludedNodesChanged)="onExcludedSelectionChange($event)"
          >
        </faro-tree-select>
      }
    </div>
    <div>
      <faro-dialog-panel header="Medium"></faro-dialog-panel>
      <div class="dialog-options">
        @for (mediaType of availableMediaTypes; track mediaType) {
          <div class="dialog-options-entries">
            <div class="checkbox-label">{{ mediaType.label }}</div>
            <div>
              <p-toggleSwitch
                [(ngModel)]="mediaType.active"
                ariaLabel="In {{ mediaType.label }} suchen"
              ></p-toggleSwitch>
            </div>
          </div>
        }
      </div>
      <div class="divider"></div>
      <faro-dialog-panel header="Art der Suche"></faro-dialog-panel>
      <div class="dialog-options">
        <div class="dialog-options-entries">
          <div class="checkbox-label">In Unterlagen, Protokolle, Dopesheets</div>
          <div>
            <p-toggleSwitch
              name="searchInDocText"
              [(ngModel)]="searchInDocumentTexts"
              ariaLabel="Nicht in Unterlagen, Protokolle, Dopesheets suchen"
            ></p-toggleSwitch>
          </div>
        </div>
        <div class="dialog-options-entries">
          <div class="checkbox-label">Sportfilter einblenden</div>
          <div>
            <p-toggleSwitch
              name="includeSportsFilters"
              [(ngModel)]="includeSportsFilters"
              ariaLabel="Sportfilter einblenden"
            ></p-toggleSwitch>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="dialog-footer footer-space-between">
    <div>
      @if (!areProfileSettingsDefault) {
        <button
          data-no-search
          class="dialog-secondary-button align-start"
          type="button"
          pButton
          icon="pi pi-replay"
          (click)="resetSearchSettings()"
          [disabled]="areProfileSettingsDefault"
          label="Auf Standard zurücksetzen"
        ></button>
      }
    </div>
    <div class="profile-action-buttons">
      <button
        #saveSettingsButton
        data-no-search
        class="search-button"
        type="button"
        pButton
        icon="pi pi-check"
        (click)="save()"
        label="Speichern"
      ></button>
      <button
        data-no-search
        class="dialog-secondary-button"
        type="button"
        pButton
        icon="pi pi-times"
        (click)="closeDialog()"
        label="Abbrechen"
      ></button>
    </div>
  </div>
</div>
